import { SectionDiv } from "../../Section/Components/SectionDiv";

export function HistorySectionFallback() {
    return (
        <SectionDiv className="mt-3 h-[500px]">
            <h3 className="mb-3">History:</h3>
            <p>(Error loading history)</p>
        </SectionDiv>
    );
}
